export const CAMPAIGN_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'];

export function campaignParams(search) {
  const params = new URLSearchParams(search);
  return Object.fromEntries(CAMPAIGN_KEYS.flatMap(key => {
    const value = params.get(key)?.trim();
    const hasControl = value && Array.from(value).some(character => {
      const code = character.charCodeAt(0);
      return code < 32 || code === 127;
    });
    return value && value.length <= 200 && !hasControl ? [[key, value]] : [];
  }));
}
